import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseController } from '@rensa/shared/base-controller';
import { ItemType } from '@rensa/shared/enums/item-type.enum';
import { ListItem } from '@rensa/modules/customer/models/list-item.model';
import { ImageService } from '@rensa/modules/customer/services/image.service';
import { ItemService } from '@rensa/modules/customer/services/item.service';
import { environment } from '@rensa/environments/environment';

//TODO: Technical debt > combineer deze class met trainingen.component.ts (pbi 46111)
@Component({
    selector: 'app-kenniscafe',
    templateUrl: './kenniscafe.component.html',
    styleUrls: ['../component-styles.css'],
})
export class KenniscafeComponent extends BaseController implements OnInit, OnDestroy {
    items: ListItem[] = [];

    constructor(private itemService: ItemService, private imageService: ImageService) {
        super();
        environment.itemType = ItemType.KennisCafe;
    }

    ngOnInit(): void {
        this.addSubscription(
            this.itemService.fetchAll(ItemType.KennisCafe).subscribe((items) => {
                this.items = items;
                this.items.forEach((item) => this.setImage(item));
            })
        );
    }

    setImage(item: ListItem): void {
        if (!item.thumbnailImage) {
            return;
        }

        this.imageService
            .fetchBy(item.thumbnailImage)
            .then((result) => this.blobToImage(result, item))
            .catch((error) => console.error(error));
    }

    ngOnDestroy(): void {
        this._ngOnDestroy();
    }

    private blobToImage(blob: Blob, item: ListItem): void {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => (item.headerBase64Image = reader.result);
    }
}
